/**
 * Type for prescription entity
 */
export enum PrescriptionTypeEnum {
    Medication = 'medication',
    Procedure = 'procedure',
}
